import { RepeaterRow, Row, Items, InputCell } from './types';

export const isRepeater = (row: Row): row is RepeaterRow => row.hasOwnProperty('items');
export const isInputCel = (row: Row): row is InputCell => row.hasOwnProperty('defaultValue');

export const createNewItemGroup = (items: Items): Items =>
  Object.values(items).reduce<Items>((acc, item) => {
    if (isRepeater(item)) {
      acc[item.id] = {
        ...item,
        items: [createNewItemGroup(item.items[0])],
      };
    } else if (isInputCel(item)) {
      acc[item.id] = {
        ...item,
        value: item.defaultValue ?? '',
      };
    } else {
      acc[item.id] = {
        ...item,
        value: '',
      };
    }
    return acc;
  }, {});
